import Modal from "components/modal/Modal";
import ModalFooter from "components/modal/ModalFooter";

type DiscardMessageModalProps = {
  onDismiss: () => void;
  onCancel: () => void;
  onConfirm: () => void;
};

export default function DiscardMessageModal({
  onDismiss,
  onCancel,
  onConfirm
}: DiscardMessageModalProps) {
  return (
    <Modal
      header={<h3 className="m-0">Radera meddelandet</h3>}
      onDismiss={onDismiss}
      modalTitle="discard message"
      testId="discard-messages-modal"
      size="xs"
      footer={
        <ModalFooter
          onCancel={onCancel}
          onConfirm={onConfirm}
          confirmText="Ja, jag vill radera meddelandet"
          justifyActions="end"
          actionsDefaultSize="sm"
          actionsClassName="mt-4"
        />
      }
    >
      <div>
        <h5 className="fw-semi-bold">
          Är du säker på att du vill radera meddelandet?
        </h5>
        <p>Alla dina ändringar går förlorade.</p>
      </div>
    </Modal>
  );
}
